import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers'
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo'

interface DateInputProps {
	name?: string
	onChange: any, 
	value: any, 
	autoFocus?: any
	onBlur?: any
}

const DateInput = ({ onChange, value, autoFocus, name, onBlur }: DateInputProps) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<DemoContainer
				sx={{
					'& input': {
						padding: 0,
						color: '#495057',
						fontFamily: 'inherit',
						fontSize: '1rem',
						borderColor: '#ced4da'
					},
					'input::placeholder': {
						opacity: '0.8 !important'
					},
					//forrm-control styles
					'& .MuiInputBase-root': {
						backgroundClip: 'padding-box',
						fontFamily: 'inherit',
						height: 'calc(1.5em + 0.75rem + 2px)',
						padding: '0.375rem 0.75rem',
						fontSize: '1rem',
						fontWeight: '400',
						lineHeight: '1.5'
					},

					'& .MuiOutlinedInput-root': {
						'& fieldset': {
							border: '1px solid #ced4da',
							transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out'
						},

						'&:hover fieldset': {
							border: '1px solid #ced4da'
						},

						//form-control:focus
						'&.Mui-focused fieldset': {
							//border: '1px solid #167b91',
							//boxShadow: '0 0 0 0.2rem rgba(0, 123, 255, 0.25)'

							color: '#495057',
							//backgroundColor: '#fff',
							borderColor: '#80bdff',
							outline: 0,
							boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
						}
					},
					// Remove validation-related styles
					'.Mui-error': {
						color: 'inherit !important'
					},
					'.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
						//borderColor: '#e5e7eb',
						borderColor: 'inherit !important',
						opacity: 'inherit !important',
						outline: 'inherit !important'
					}

					/*
					'& .MuiInputBase-root:focus-within': {
						backgroundClip: 'padding-box',
						border: '1px solid #167b91',
						borderColor: '#167b91'
					}
					// Additional styles
					'.MuiPickersLayout-root .MuiPickersLayout-actionBar': {
						justifyContent: 'center'
					},
					'.MuiButtonBase-root.MuiButton-root:focus': {
						//outline: 'none !important'
					},
					'.MuiButtonBase-root.MuiMenuItem-root.MuiMenuItem-gutters.Mui-selected': {
						backgroundColor: '#80bdff !important'
					},

					'.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-edgeEnd': {
						//outline: 'none !important'
					},
					'.MuiButtonBase-root.MuiPickersDay-root.MuiPickersDay-dayWithMargin.MuiPickersDay-today':
						{
							border: '1px solid #80bdff !important'
							//outline: 'none !important'
						},
					'.MuiButtonBase-root.MuiPickersDay-root.Mui-selected': {
						backgroundColor: '#80bdff !important',
						border: 'none !important',
						outline: 'none !important'
					},
					'.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-edgeStart.MuiIconButton-sizeMedium.MuiPickersArrowSwitcher-button':
						{
							//outline: 'none !important'
						},
					'.MuiFormControl-root.MuiTextField-root': {
						backgroundColor: '#fff !important'
					},
					'.MuiPickersYear-yearButton.Mui-selected': {
						backgroundColor: '#80bdff !important'
						//outline: 'none !important'
					},
					'.MuiTypography-root.MuiTypography-body2': {
						fontSize: '1rem !important',
						fontFamily: 'inherit'
					}*/
				}}
				components={['DatePicker']}
			>
				<DemoItem>
					<DatePicker
						className="form-control"
						onChange={onChange}
						value={value}
						format="DD/MM/YYYY"
						autoFocus={autoFocus}
					/>
				</DemoItem>
			</DemoContainer>
		</LocalizationProvider>
	)
}
export default DateInput

/*
//NOTE: align Ok button to the center
.MuiPickersLayout-root .MuiPickersLayout-actionBar {
	justify-content: center;
}

.MuiButtonBase-root.MuiButton-root:focus {
	outline: none !important;
}

// NOTE: selected numbers
.MuiButtonBase-root.MuiMenuItem-root.MuiMenuItem-gutters.Mui-selected {
	background-color: #80bdff !important ;
}

// NOTE: keep the input always width 100%


// NOTE: input icon
.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-edgeEnd {
	outline: none !important;
}

// NOTE: current date border
.MuiButtonBase-root.MuiPickersDay-root.MuiPickersDay-dayWithMargin.MuiPickersDay-today {
	border: 1px solid #80bdff !important;
	outline: none !important;
}

// NOTE: date selected
.MuiButtonBase-root.MuiPickersDay-root.Mui-selected {
	background-color: #80bdff !important;
	border: none !important;
	outline: none !important;
}

// NOTE: outline in next arrow
.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-edgeStart.MuiIconButton-sizeMedium.MuiPickersArrowSwitcher-button {
	outline: none !important;
}

// NOTE: background color in mobile version
.MuiFormControl-root.MuiTextField-root {
	background-color: #fff !important;
}

// NOTE: year selected
.MuiPickersYear-yearButton.Mui-selected {
	background-color: #80bdff !important;
	outline: none !important;
}
.MuiTypography-root.MuiTypography-body2 {
	font-size: 1rem !important;
	font-family: 'inherit';
}*/
